import React from 'react';

import GenericTile, { type TileProps } from '@atlaskit/tile';

import { getGoogleDriveFileTypeIcon } from '../../constants/3p-product-configs/google/file-type-icon';
import { getSharePointFileTypeIcon } from '../../constants/3p-product-configs/sharepoint/file-type-icon';
import { ProductKeys } from '../../constants/product-keys';

export const getFileTypeIconFor3P = (
	productKey: string,
	subtype: string | null | undefined,
): (() => React.JSX.Element) | null => {
	switch (productKey) {
		case ProductKeys.GoogleDrive:
			return getGoogleDriveFileTypeIcon(subtype);
		case ProductKeys.Sharepoint:
			return getSharePointFileTypeIcon(subtype);
		default:
			return null;
	}
};

type FileTypeIconTileProps = {
	Glyph: () => React.JSX.Element;
	label: string;
	size?: TileProps['size'];
};

/**
 * Renders a 3P file-type glyph wrapped in `GenericTile`.
 */
export const FileTypeIconTile = ({
	Glyph,
	label,
	size = 'medium',
}: FileTypeIconTileProps): React.JSX.Element => (
	<GenericTile label={label} size={size}>
		<Glyph />
	</GenericTile>
);
